/**
 * grizzly-web — TypeScript SPA entry point.
 *
 * Initializes dayjs, registers all Galaxy route handlers via views/index.ts,
 * and exports mountApp for the HTML template.
 */

// dayjs plugin initialization — must happen before any dayjs usage
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime.js'
dayjs.extend(relativeTime)

// Router
export { initRouter, navigate, dispatchRoute, route } from './router.js'

// Shared utilities (used by components and views)
export {
  renderMd,
  relTime,
  codeBlock,
  codeDiff,
  esc,
  escJs,
  showToast,
  formatCost,
  formatTokens,
  formatDuration,
} from './components/shared.js'

// Views — side-effect: registers all route handlers on import
import './views/index.js'

// App initialization
export { mountApp } from './app.js'

// Bootstrap — side-effect: registers _cbCopy on window and triggers
// mountApp() on DOM ready. Replaces inline <script> blocks formerly in
// index.html so the CSP can drop `'unsafe-inline'` for script-src.
import './bootstrap.js'
